module.exports = {
  roles: {
    SUPER_ADMIN: 0,
    SUPER_USER: 1,     // formerly ADMIN — full visibility, can manage all users and roles
    BASIC_CUSTOMER: 2,
    ADMIN: 3,          // limited admin — can only see/manage users they created
  },
  // Aplicaciones que solo el Super Admin puede asignar. Debe coincidir con
  // backend/config.js -> superAdminOnlyApplications. Esconderlas aqui es por
  // comodidad; quien lo impide de verdad es el servidor.
  //   4 = ShopXpert
  superAdminOnlyApplications: [4],
};
